export const environment = {
  version: '8.0.3',
  production: false,
  deployUrl: 'https://dev.pricing.calenso.com',
};
